import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_LMP_DATE_REQUEST: '',
  GET_LMP_DATE_SUCCESS: '',
  GET_LMP_DATE_FAILURE: '',

  SAVE_LMP_DATE_REQUEST: '',
  SAVE_LMP_DATE_SUCCESS: '',
  SAVE_LMP_DATE_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityLMP');

export default types;
